<template>
  <div class="container nav-bar">
    <el-card shadow="hover" :body-style="{ padding: '0' }" class="nav-card">
      <div class="nav-row">
        <div class="all-cat-btn"><i class="fas fa-bars"></i> 全部分类</div>
        <div class="nav-links">
          <div v-for="(item, index) in navItems" :key="index" class="nav-item" @click="goToRoute(item)">
            {{ item }} <i v-if="item === '积分商城'" class="fas fa-fire" style="color:red;font-size:12px;"></i>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script setup>
// '走进金试'
const navItems = ['首页', '积分商城', '品牌专区', '技术服务', '关于我们' ];
function goToRoute(val) {
  // 这里可以根据需要添加路由跳转逻辑
  switch (val) {
    case '首页':
      window.location.href = '/pc.html#/';
      break;
    case '积分商城':
      // window.location.href = '/pc.html#/integral-mall';
      break;
    case '品牌专区':
      window.location.href = '/pc.html#/brands';
      break;
    case '技术服务':
      // window.location.href = '/tech-services';
      break;
    case '关于我们':
      window.location.href = '/pc.html#/about';
      break;
    // case '走进金试':
    //   window.location.href = '/pc.html#/ximi';
    //   break;
    default:
      break;
  }
}
</script>

<style scoped>
.nav-bar {
  margin-top: 15px;
  margin-bottom: 20px;
}

.nav-card {
  border-radius: 8px;
}

.nav-row {
  display: flex;
  align-items: center;
  height: 50px;
  font-size: 15px;
  font-weight: 600;
}

.all-cat-btn {
  width: 240px;
  height: 100%;
  background: var(--text-main);
  color: #fff;
  display: flex;
  align-items: center;
  padding: 0 20px;
  gap: 10px;
  cursor: pointer;
  border-radius: 8px 0 0 8px;
  transition: 0.3s;
}

.all-cat-btn:hover {
  background: var(--tech-blue);
}

.nav-links {
  display: flex;
  gap: 40px;
  margin-left: 30px;
}

.nav-item {
  cursor: pointer;
  transition: 0.3s;
}

.nav-item:hover {
  color: var(--tech-blue);
}
</style>